export default {"src":"/_next/static/media/logo_wheel_left.4b84aca3.svg","height":104,"width":208};